/* eslint-disable */
import { useEffect } from 'react';
import { Row, Col } from "antd";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import Component from "../../Components";
import { useDispatch, useSelector } from "react-redux";
import { Auth } from '../..//redux/Actions';
import LoginRequest from "../../config";
import Spinner from 'Components/Spinner/Spiner';
import logo from "../../assests/images/login.jpg";
import { CommonText } from "../../Constant/CommonText";

const Login = () => {
    const { Button } = Component;
    const dispatch = useDispatch();
    const { loading } = useSelector(state => state?.auth);
    const { instance, inProgress, accounts } = useMsal();


    const params = new URLSearchParams(window.location.search);
    const backtologin = params.get('backtologin');

    const activeAccount = accounts.length > 0 ? accounts[0] : null;

    useEffect(() => {
        if (inProgress === InteractionStatus.None && !activeAccount && backtologin === 'true') {
            instance.loginRedirect(LoginRequest.loginRequest).catch(console.error);
        }
    }, [inProgress, activeAccount, backtologin, instance]);

    const handleLogin = () => {
        instance.loginRedirect(LoginRequest.loginRequest).catch(console.error);
    };

    useEffect(() => {
        if (inProgress === InteractionStatus.None && activeAccount) {
            // Token acquisition (Graph + API) is handled in getDetailsSaga.
            dispatch(Auth.getDetailsRequest({ instance, activeAccount }));
        }
    }, [inProgress, activeAccount, instance, dispatch]);

    return (
        <>
            {(loading || inProgress == "startup" || inProgress == 'handleRedirect') && <Spinner />}
            <Row justify="center" align="middle" style={{ height: '100vh' }}>
                <Col sm={6} style={{ textAlign: 'center' }}>
                    <div>
                        <img src={logo} alt="Logo" style={{ maxWidth: '100%', height: 'auto' }} />
                        <h5 style={{ color: '#3C3C3C', fontSize: '38px' }}>{CommonText.APP_NAME_TEXT}</h5>
                        <Button title="Log In" className='login-btn' onClick={handleLogin}>Log In</Button>
                    </div>
                </Col>

            </Row>
        </>
    );
};

export default Login;
